<template>
  <v-row>
    <v-col cols="12" REGISTER ALERT v-if="user && user.access && !user.verified_phone">
      <v-alert type="error" :value="true" :class="`${arabic?'arFont':'enFont'}`">
        {{  i18n["please_verify_your_number"] }}
        <v-card-actions>
          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="dialog = true">
            {{  i18n["verify_your_phone_number"] }}
          </v-btn>
        </v-card-actions>
        <v-dialog v-model="dialog" persistent max-width="600">
          <v-card>
            <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">{{ i18n["verify_phone_number"] }}</v-card-title>
            <v-card-text>
              <v-row class="align-center">
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`">
                  <v-autocomplete
                    :items="countries"
                    v-model="country_code"
                    :label="i18n['country_code']"
                    autocomplete="disabled"
                    outlined
                    :filter="filterObject"
                    hide-details
                    clearable
                    dense
                    :loading="loading"
                    item-value="callingCodes"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item.callingCodes}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item.name}} | {{item.callingCodes}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`">
                  <v-text-field
                    :label="i18n['phone_number']"
                    :class="`${arabic?'arFont':'enFont'}`"
                    outlined
                    dense
                    :disabled="submit"
                    :loading="loading"
                    @keypress="isNumber($event)"
                    hide-details
                    v-model="phone_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`">
                  <v-btn color="primary" @click.native="sendSMS()" :loading="loading" :disabled="submit" :class="`${arabic?'arFont':'enFont'}`">{{ i18n["send_secret_code"] }}</v-btn>
                </v-col>
                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} text-center`" v-if="submit">
                  <v-text-field
                    :label="i18n['secret_code']"
                    :class="`${arabic?'arFont':'enFont'}`"
                    outlined
                    dense
                    :loading="loading"
                    @keypress="isNumber($event)"
                    hide-details
                    v-model="secret"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`"  v-if="submit">
                  <v-btn color="primary" @click.native="sendSecret()" :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{ i18n["confirm_phone_number"] }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="dialog = false" :class="`${arabic?'arFont':'enFont'}`">{{ i18n['cancel'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import countries from '../countries-ash.json'
export default {
  data() {
      return {
        dialog:false,
        phone_number:null,
        country_code:null,
        submit:null,
        loading:null,
        secret:null,
        countries:countries.map(x=>{return{...x, callingCodes:x.callingCodes[0]}}),
        session_token:null,
      }
  },
  methods:{
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async sendSMS() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.phone_number) {
          this.$emit('snackbarNotification', this.i18n['phone_number_reqired'], 'error')
          this.loading = false
        }
        this.submit = true
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification', value:{phone_number:`${this.country_code}${this.phone_number}`}})
        this.session_token = r.session_token
        // console.log(r)
        this.loading = false
      })
    },
    async sendSecret() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.secret) {
          this.$emit('snackbarNotification', this.i18n["please_input_secret_code"], 'error')
          this.loading = false
        }
        let s_o = { secret:this.secret, session_token:this.session_token, phone_number:`${this.country_code}${this.phone_number}` }
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification-check', value:s_o})
        if(r.error) {
          this.$emit('snackbarNotification', this.i18n["wrong_secret_code_try_again"], 'error')
          this.submit = false
          this.secret = null
        } else {
          this.dialog = false
          this.secret = null
          this.$store.state.user = await this.$store.dispatch('getUser')
          this.$emit('snackbarNotification', this.i18n["phone_number_confirmed_successfully"], 'success')
        }
        // console.log(r)
        this.loading = false
      })
    },
    isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode != 46 && charCode != 45 && charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
    paymentMethods(){
      return this.$store.state.paymentMethods
    },
  },
}
</script>

<style>

</style>